const wix = (id, w = 1200, h = 800) =>
  `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/${id}`;

export const IMAGES = {
  hero: "https://static.wixstatic.com/media/ea26fd_e142fd7bcd8c46219312b22e8a91bb3c~mv2_d_4000_2447_s_4_2.jpeg/v1/fill/w_2100,h_1300,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ea26fd_e142fd7bcd8c46219312b22e8a91bb3c~mv2_d_4000_2447_s_4_2.jpeg",
  cantiere: wix("11062b_0ffbfbeb256041f2984e0f7c6a618a15~mv2.jpeg", 2100, 900),
  team: wix("dd74e5_4874bba8f50e4dd8a7575acb6cd710d9~mv2.jpg", 900, 670),
  dettaglio: wix("dd74e5_6a62ffee0b40488eb03d0a306079cbd6~mv2.jpeg", 900, 760),
  recente1: wix("dd74e5_285e3f61a306452caac7428fc6ab503a~mv2.jpg", 1400, 930),
  recente2: wix("dd74e5_72b4f2b2da4b4c2ab15fc6314f11603b~mv2.jpg", 800, 1200),
  recente3: wix("dd74e5_18a3e26b05c44306b49c893e155c66d6~mv2.jpg", 1000, 630),
  contatti: wix("dd74e5_0f322ee69b50408fbb7c780706d1a763~mv2.jpeg", 1800, 700),
};

export const CONTACTS = {
  legalName: "Edilcomplex2020 S.r.l.",
  piva: "02558740466",
  pec: "edilcomplex2020srl@pec.cgn.it",
  phone: "+39 320 890 8036",
  phoneHref: "tel:+393208908036",
  whatsapp: "https://wa.me/393208908036",
  email: "edilcomplex2020@gmail.com",
  address: "Via delle Piastre 13/15, Guamo — 55012 Capannori (LU)",
  hours: "Lun — Ven · 9:00 — 18:00",
  instagram: "https://www.instagram.com/edilcomplex2020",
  googleMaps:
    "https://www.google.com/maps?q=Via+delle+Piastre+13%2F15%2C+55012+Capannori+LU&output=embed",
  mapsLink: "https://maps.app.goo.gl/gqXeuqP1jK13rwTn6",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/servizi", label: "Servizi" },
  { to: "/progetti", label: "Progetti" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/contatti", label: "Contatti" },
];

export const MARQUEE_ITEMS = [
  "Robustezza",
  "Eleganza",
  "Innovazione Tecnologica",
  "Finiture di Pregio",
  "Eco-Sostenibilità",
  "Design Toscano",
];

export const SERVICES = [
  {
    id: "costruzioni",
    num: "01",
    title: "Costruzioni Residenziali",
    short: "Nuove costruzioni chiavi in mano con tecnologie avanzate, costi certi e tempi garantiti.",
    desc: "Realizziamo abitazioni ed edifici residenziali, seguendo il lavoro dalle prime fasi fino alla consegna. Ci occupiamo dell'organizzazione del cantiere e della realizzazione delle opere, lavorando a stretto contatto con tecnici e progettisti. Prestiamo particolare attenzione alla qualità dei materiali, alla cura delle lavorazioni e al rispetto di tempi e progetto.",
    img: wix("dd74e5_ce77db3b16014149a63cdd39a7ca3d59~mv2.jpeg", 1100, 700),
  },
  {
    id: "ristrutturazioni",
    num: "02",
    title: "Ristrutturazioni Edilizie",
    short: "Riqualificazione completa di appartamenti, casali e immobili commerciali.",
    desc: "Le ristrutturazioni sono essenziali per migliorare il comfort abitativo ed energetico, o per ampliare edifici esistenti. Offriamo competenze specializzate in manutenzioni periodiche, risanamenti, ristrutturazioni e riconversioni di capannoni e fabbricati. Ci dedichiamo anche al restauro e all'ampliamento delle strutture o di parti di esse, garantendo un risultato di alta qualità in ogni intervento.",
    img: wix("dd74e5_2f537ee589664bb187519a23dcc4fa08~mv2.jpg", 1100, 700),
  },
  {
    id: "restauri",
    num: "03",
    title: "Restauri e Risanamenti",
    short: "Interventi conservativi su edifici residenziali e commerciali, con rispetto della materia.",
    desc: "Interveniamo su edifici esistenti con lavori di restauro e risanamento, dalle singole opere fino agli interventi più completi. Valutiamo ogni immobile in base alle sue caratteristiche, cercando di conservarne gli elementi di valore e intervenendo dove necessario con tecniche e materiali adeguati. Un lavoro fatto con attenzione, soprattutto quando si opera su fabbricati che hanno una storia e caratteristiche da rispettare.",
    img: wix("dd74e5_4874bba8f50e4dd8a7575acb6cd710d9~mv2.jpg", 1100, 740),
  },
  {
    id: "piscine",
    num: "04",
    title: "Progettazione e Costruzione Piscine",
    short: "Piscine di lusso con rivestimenti in quarzo naturale, per privati e strutture commerciali.",
    desc: "Realizziamo piscine di qualsiasi stile e dimensione, o interveniamo nella ristrutturazione di quelle esistenti, curando ogni dettaglio dalla progettazione alla costruzione. Il nostro punto forte è l'esclusività nella fornitura e l'impeccabile posa dei rivestimenti a base di quarzo naturale: il miglior prodotto sul mercato, certificato e garantito. Questo ci rende il punto di riferimento per qualsiasi struttura di lusso in ambito privato e commerciale.",
    img: wix("dd74e5_18a3e26b05c44306b49c893e155c66d6~mv2.jpg", 1100, 690),
  },
  {
    id: "commerciale",
    num: "05",
    title: "Strutture Commerciali e Industriali",
    short: "Edifici funzionali per produzione, trasformazione, retail e uffici.",
    desc: "Realizziamo e ristrutturiamo edifici destinati ad attività commerciali, artigianali e industriali. Ogni intervento viene affrontato tenendo conto dell'utilizzo degli spazi, delle esigenze dell'attività e degli aspetti tecnici della struttura. Dalla costruzione alle opere esterne, seguiamo il cantiere con un approccio pratico e attento alle necessità del cliente.",
    img: wix("dd74e5_ff756117d96040ecb80079956e94eddb~mv2.jpeg", 1100, 700),
  },
  {
    id: "gestione",
    num: "06",
    title: "Gestione e Coordinamento Progetti",
    short: "Project management completo, supervisione cantieri e coordinamento maestranze.",
    desc: "Una solida progettazione è la base del successo, ma la riuscita di un progetto dipende anche dalle fasi successive: organizzazione, monitoraggio, documentazione e controllo costante dell'avanzamento lavori. La supervisione continua garantisce qualità e rispetto delle tempistiche. Vi seguiamo passo dopo passo, senza lasciarvi mai soli: ogni step avrà la nostra supervisione.",
    img: wix("dd74e5_0f322ee69b50408fbb7c780706d1a763~mv2.jpeg", 1100, 700),
  },
];

export const PILLARS = [
  { title: "Un team di professionisti", desc: "Tecnici e operai qualificati, formati internamente e coordinati dai nostri uffici." },
  { title: "Alte finiture", desc: "Materiali selezionati e fornitori leader del settore, per risultati di pregio." },
  { title: "Ampia esperienza", desc: "Trent'anni di cantieri in Toscana, rinnovati nel 2020 con tecnologie all'avanguardia." },
  { title: "Sostenibili e affidabili", desc: "Costi e tempi di consegna certi, con assistenza continua in ogni fase del lavoro." },
];

export const PROJECTS = [
  {
    id: "casa-lucca",
    index: "I",
    title: "Progettazione Casa a Lucca",
    location: "Lucca, Toscana",
    category: "Residenziale",
    year: "2024",
    desc: "Progettazione e realizzazione di un'abitazione privata nel cuore della campagna lucchese: volumi essenziali, materiali naturali e finiture di pregio.",
    images: [
      wix("dd74e5_2f537ee589664bb187519a23dcc4fa08~mv2.jpg", 1200, 1200),
      wix("dd74e5_1e73555c44ed4f75893ca6b10486a245~mv2.jpg", 900, 900),
      wix("dd74e5_04b9083e06644ad2aa80766ce81480d3~mv2.jpg", 1400, 1400),
      wix("dd74e5_23b7268b1392435bac44c7ce8daa4c72~mv2.jpg", 900, 900),
      wix("dd74e5_8f9d992e8af14490bd35df5ec6431b41~mv2.jpg", 900, 905),
    ],
  },
  {
    id: "piscina-barberino",
    index: "II",
    title: "Realizzazione Piscina a Barberino",
    location: "Barberino, Toscana",
    category: "Piscine",
    year: "2024",
    desc: "Piscina interrata su misura con rivestimento in quarzo naturale: uno specchio d'acqua integrato nel paesaggio toscano, curato in ogni dettaglio.",
    images: [
      wix("dd74e5_2d1b330ed68b4d40b9bcdf0a95f88a84~mv2.jpg", 1600, 1000),
      wix("dd74e5_314853756679407db972a514f2b40739~mv2.jpg", 900, 760),
    ],
  },
  {
    id: "casa-pietrasanta",
    index: "III",
    title: "Costruzione Casa a Marina di Pietrasanta",
    location: "Marina di Pietrasanta, Versilia",
    category: "Nuova Costruzione",
    year: "2023",
    desc: "Nuova costruzione residenziale a pochi passi dal mare della Versilia: struttura moderna, efficienza energetica e design contemporaneo.",
    images: [
      "/images/pietrasanta-1.jpg",
      "/images/pietrasanta-2.jpg",
      "/images/pietrasanta-3.jpg",
      "/images/pietrasanta-4.jpg",
      "/images/pietrasanta-5.jpg",
      "/images/pietrasanta-6.jpg",
    ],
  },
];

export const CHAPTERS = [
  {
    num: "I",
    title: "Le Origini",
    text: "Trent'anni di esperienza nel settore edilizio, costruiti cantiere dopo cantiere in tutta la Toscana. Una storia fatta di materia, precisione e rapporti di fiducia con clienti, architetti e fornitori leader del settore.",
    img: wix("dd74e5_6a62ffee0b40488eb03d0a306079cbd6~mv2.jpeg", 1000, 840),
  },
  {
    num: "II",
    title: "L'Evoluzione 2020",
    text: "Nel 2020 l'azienda si rinnova: nasce Edilcomplex2020, che combina l'esperienza consolidata con tecnologie all'avanguardia per offrire soluzioni complete nel settore edilizio, dalla progettazione all'arredamento finale.",
    img: wix("dd74e5_4874bba8f50e4dd8a7575acb6cd710d9~mv2.jpg", 1000, 740),
  },
  {
    num: "III",
    title: "Tecnologia e Materia",
    text: "Tecnologie avanzate, profonda conoscenza dei materiali e design contemporaneo. Specializzati in ristrutturazioni rapide e di qualità e costruzioni chiavi in mano, con la garanzia di costi e tempi di consegna certi.",
    img: wix("dd74e5_ff756117d96040ecb80079956e94eddb~mv2.jpeg", 1000, 760),
  },
  {
    num: "IV",
    title: "Garanzia e Futuro",
    text: "Assistenza completa e continua in tutte le fasi del lavoro, con la collaborazione di tecnici altamente qualificati. Non lasciamo mai soli i nostri clienti: ogni step ha la nostra supervisione, oggi e domani.",
    img: wix("dd74e5_ce77db3b16014149a63cdd39a7ca3d59~mv2.jpeg", 1000, 680),
  },
];

export const STATS = [
  { value: "30+", label: "Anni di esperienza" },
  { value: "24h", label: "Risposta garantita" },
  { value: "06", label: "Aree di intervento" },
  { value: "100%", label: "Assistenza continua" },
];

export const SERVICES_EN = [
  {
    id: "costruzioni",
    num: "01",
    title: "New Residential Construction",
    short: "Turnkey new builds with advanced technology, fixed costs and guaranteed timelines.",
    desc: "We build homes and residential buildings, following the work from the earliest phases through to delivery. We handle site organisation and the construction works themselves, working closely with technicians and designers. We pay particular attention to the quality of materials, the care of workmanship and respect for timelines and design.",
    img: wix("dd74e5_ce77db3b16014149a63cdd39a7ca3d59~mv2.jpeg", 1100, 700),
  },
  {
    id: "ristrutturazioni",
    num: "02",
    title: "Building Renovations",
    short: "Complete renovation of apartments, farmhouses and commercial properties.",
    desc: "Renovations are essential to improve living and energy comfort, or to extend existing buildings. We offer specialist expertise in periodic maintenance, remediation, renovations and the conversion of warehouses and industrial buildings. We also handle the restoration and extension of structures or parts of them, guaranteeing a high-quality result in every project.",
    img: wix("dd74e5_2f537ee589664bb187519a23dcc4fa08~mv2.jpg", 1100, 700),
  },
  {
    id: "restauri",
    num: "03",
    title: "Restoration & Remediation",
    short: "Conservative works on residential and commercial buildings, respecting the original fabric.",
    desc: "We work on existing buildings with restoration and remediation works, from individual jobs to the most complete interventions. We assess each property based on its characteristics, seeking to preserve its valuable elements and intervening where necessary with suitable techniques and materials. Work carried out with care, especially when operating on buildings that have a history and features to respect.",
    img: wix("dd74e5_4874bba8f50e4dd8a7575acb6cd710d9~mv2.jpg", 1100, 740),
  },
  {
    id: "piscine",
    num: "04",
    title: "Swimming Pool Design & Construction",
    short: "Luxury pools with natural quartz finishes, for private clients and commercial venues.",
    desc: "We build pools of any style and size, or renovate existing ones, taking care of every detail from design to construction. Our strength is the exclusive supply and flawless installation of natural quartz-based finishes: the best product on the market, certified and guaranteed. This makes us the benchmark for any luxury structure, private or commercial.",
    img: wix("dd74e5_18a3e26b05c44306b49c893e155c66d6~mv2.jpg", 1100, 690),
  },
  {
    id: "commerciale",
    num: "05",
    title: "Commercial & Industrial Buildings",
    short: "Functional buildings for production, processing, retail and offices.",
    desc: "We build and renovate buildings for commercial, artisanal and industrial activities. Every project is approached considering the use of space, the needs of the business and the technical aspects of the structure. From construction to external works, we manage the site with a practical approach, attentive to the client's needs.",
    img: wix("dd74e5_ff756117d96040ecb80079956e94eddb~mv2.jpeg", 1100, 700),
  },
  {
    id: "gestione",
    num: "06",
    title: "Project Management & Coordination",
    short: "Full project management, site supervision and contractor coordination.",
    desc: "Solid design is the foundation of success, but a project's outcome also depends on the following phases: organisation, monitoring, documentation and constant control of work progress. Continuous supervision guarantees quality and on-time delivery. We follow you step by step, never leaving you alone: every stage has our supervision.",
    img: wix("dd74e5_0f322ee69b50408fbb7c780706d1a763~mv2.jpeg", 1100, 700),
  },
];

export const PROJECTS_EN = [
  {
    id: "casa-lucca",
    index: "I",
    title: "Home Design in Lucca",
    location: "Lucca, Tuscany",
    category: "Residential",
    year: "2024",
    desc: "Design and construction of a private home in the heart of the Lucca countryside: clean volumes, natural materials and premium finishes.",
    images: PROJECTS[0].images,
  },
  {
    id: "piscina-barberino",
    index: "II",
    title: "Swimming Pool in Barberino",
    location: "Barberino, Tuscany",
    category: "Pools",
    year: "2024",
    desc: "A bespoke in-ground pool with a natural quartz finish: a body of water integrated into the Tuscan landscape, perfected in every detail.",
    images: PROJECTS[1].images,
  },
  {
    id: "casa-pietrasanta",
    index: "III",
    title: "New Build in Marina di Pietrasanta",
    location: "Marina di Pietrasanta, Versilia",
    category: "New Build",
    year: "2023",
    desc: "A new residential build just steps from the Versilia sea: modern structure, energy efficiency and contemporary design.",
    images: PROJECTS[2].images,
  },
];

export const CHAPTERS_EN = [
  {
    num: "I",
    title: "The Origins",
    text: "Thirty years of construction experience, built site after site across Tuscany. A story of raw matter, precision and relationships of trust with clients, architects and leading industry suppliers.",
    img: CHAPTERS[0].img,
  },
  {
    num: "II",
    title: "The 2020 Evolution",
    text: "In 2020 the company renewed itself: Edilcomplex2020 was born, combining consolidated experience with cutting-edge technologies to offer complete solutions in the construction sector, from design to final furnishing.",
    img: CHAPTERS[1].img,
  },
  {
    num: "III",
    title: "Technology & Matter",
    text: "Advanced technologies, deep knowledge of materials and contemporary design. Specialised in fast, high-quality renovations and turnkey construction, with guaranteed costs and delivery times.",
    img: CHAPTERS[2].img,
  },
  {
    num: "IV",
    title: "Guarantee & Future",
    text: "Complete, continuous assistance in every phase of the work, with the collaboration of highly qualified technicians. We never leave our clients alone: every step has our supervision, today and tomorrow.",
    img: CHAPTERS[3].img,
  },
];

export const PILLARS_EN = [
  { title: "A team of professionals", desc: "Qualified technicians and workers, trained in-house and coordinated by our offices." },
  { title: "Premium finishes", desc: "Selected materials and leading industry suppliers, for top-quality results." },
  { title: "Extensive experience", desc: "Thirty years of construction sites across Tuscany, renewed in 2020 with cutting-edge technology." },
  { title: "Sustainable & reliable", desc: "Fixed costs and delivery times, with continuous assistance in every phase of the work." },
];

export const MARQUEE_ITEMS_EN = [
  "Robustness",
  "Elegance",
  "Technological Innovation",
  "Premium Finishes",
  "Eco-Sustainability",
  "Tuscan Design",
];

export const STATS_EN = [
  { value: "30+", label: "Years of experience" },
  { value: "24h", label: "Guaranteed reply" },
  { value: "06", label: "Service areas" },
  { value: "100%", label: "Ongoing support" },
];

export const FAQS = {
  eyebrow: "Domande frequenti",
  titleA: "Tutto quello che",
  titleB: "vuoi sapere",
  items: [
    {
      q: "Quanto costa una ristrutturazione chiavi in mano?",
      a: "Ogni progetto è unico: il costo dipende da metratura, stato dell'immobile e livello delle finiture. Dopo un sopralluogo gratuito prepariamo un preventivo dettagliato con costi certi e tempi di consegna garantiti, senza sorprese in corso d'opera.",
    },
    {
      q: "In quali zone operate?",
      a: "La nostra sede è a Capannori, in provincia di Lucca. Operiamo a Lucca e in tutta la Toscana — dalla Versilia a Pisa e Firenze — e valutiamo progetti in tutta Italia.",
    },
    {
      q: "Quanto dura un cantiere di ristrutturazione?",
      a: "Un appartamento richiede mediamente dalle 6 alle 12 settimane, mentre ville e nuove costruzioni richiedono tempi più lunghi. Prima dell'inizio lavori consegniamo un cronoprogramma dettagliato: i tempi concordati sono garantiti.",
    },
    {
      q: "Vi occupate anche delle pratiche burocratiche?",
      a: "Sì. Gestiamo pratiche edilizie, permessi, certificazioni e coordinamento della sicurezza in cantiere, grazie alla collaborazione con tecnici e architetti qualificati. Non devi pensare a nulla.",
    },
    {
      q: "Realizzate piscine su misura?",
      a: "Sì: progettiamo e costruiamo piscine interrate di ogni forma e dimensione, con l'esclusiva posa di rivestimenti in quarzo naturale certificato, il miglior prodotto sul mercato per estetica e durata.",
    },
    {
      q: "Posso accedere a bonus e agevolazioni edilizie?",
      a: "Valutiamo insieme le agevolazioni disponibili per il tuo intervento e ti assistiamo nella preparazione della documentazione necessaria per richiederle.",
    },
  ],
};

export const FAQS_EN = {
  eyebrow: "Frequently asked questions",
  titleA: "Everything you",
  titleB: "want to know",
  items: [
    {
      q: "How much does a turnkey renovation cost?",
      a: "Every project is unique: the cost depends on size, the condition of the property and the level of finishes. After a free site inspection we prepare a detailed quote with fixed costs and guaranteed delivery times — no surprises along the way.",
    },
    {
      q: "Which areas do you cover?",
      a: "We are based in Capannori, in the province of Lucca. We work in Lucca and across Tuscany — from Versilia to Pisa and Florence — and we consider projects throughout Italy.",
    },
    {
      q: "How long does a renovation take?",
      a: "An apartment typically takes 6 to 12 weeks, while villas and new builds require longer. Before work begins we provide a detailed schedule: the agreed timeline is guaranteed.",
    },
    {
      q: "Do you handle the paperwork and permits?",
      a: "Yes. We manage building permits, certifications and site safety coordination, working with qualified technicians and architects. You don't have to worry about a thing.",
    },
    {
      q: "Do you build custom swimming pools?",
      a: "Yes: we design and build in-ground pools of any shape and size, with exclusive installation of certified natural quartz finishes — the best product on the market for aesthetics and durability.",
    },
    {
      q: "Can I access renovation incentives or tax bonuses?",
      a: "We assess the incentives available for your project together and assist you in preparing the documentation needed to apply for them.",
    },
  ],
};
